import ajax from '@client/components/ajax'; // NOTE: old
import { LiteUser } from '@client/new/common/LiteUser.mapper';

import { TextField } from '@client/new/components/basic';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { PrimaryButton } from '@client/new/components/button';
import { GA4Configuration } from '@client/new/hooks/use-user';
import { InfoTip } from '../InfoTip';
import { trackEvent } from '@services/tracking';

export const GA4Form = (p: { creator: LiteUser }) => {
  const [state, setState] = useState<GA4Configuration>(
    p.creator.ga4Configuration ?? { measurementId: '', apiSecret: '' },
  );
  const [isSaving, setIsSaving] = useState(false);

  const submit = () => {
    setIsSaving(true);

    trackEvent({
      type: 'Google Configuration Saved',
      payload: {},
    });

    ajax
      .upsertInfluencer({ ...(p.creator as any), ga4Configuration: state })
      .then(() => toast.success('GA4 configuration was saved!'))
      .catch((err) =>
        toast.error('Error saving GA4 configuration: ' + err.message),
      )
      .finally(() => setIsSaving(false));
  };

  return (
    <div className="flex flex-col gap-5 pt-4">
      <InfoTip>
        After connecting your Google Analytics test to verify that everything
        has been set up correctly. Using the Chrome Browser? Check out the Link
        to test your Pixel implementation! Testing can also be done using the
        Test Events tool in your{' '}
        <a
          href="https://analytics.google.com/analytics"
          target="_blank"
          rel="noreferrer"
        >
          Google Analytics Dashboard.
        </a>
      </InfoTip>

      <div className="grid md:grid-cols-2 gap-5">
        <TextField
          label="Measurement Id"
          value={state.measurementId || ''}
          onChange={(e) =>
            setState((s) => ({ ...s, measurementId: e.target.value }))
          }
          placeholder="Please enter measurement Id"
          required
        />
        <TextField
          label="Access Token (optional)"
          value={state.apiSecret || ''}
          onChange={(e) =>
            setState((s) => ({ ...s, apiSecret: e.target.value }))
          }
          placeholder="Please enter Access Token"
        />
        <div />
        <PrimaryButton
          className="max-w-[120px] justify-self-end"
          onClick={submit}
          isLoading={isSaving}
          disabled={!state.measurementId}
        >
          Save
        </PrimaryButton>
      </div>
    </div>
  );
};
